/* Page « Fonds d'ecran » (sections/rp-fonds-ecran.liquid).
   - acces : une fois la page ouverte (inscription, client connecte), le navigateur s'en souvient
     (localStorage) ; le script en tete de la section l'ouvre des l'affichage aux visites suivantes ;
   - « Telecharger le pack » : les images du pack sont chargees puis rangees dans un zip fabrique ici
     (sans compression : des JPG ne gagnent rien a etre compresses), enregistre sous data-nom.zip ;
   - « Enregistrer dans Photos » (iPhone/iPad seulement) : feuille de partage avec les images,
     qui propose « Enregistrer X images » ;
   - navigateurs d'Instagram/TikTok : ils bloquent les telechargements, on affiche la marche a suivre. */
(function () {
  'use strict';

  var CLE = 'rp-fonds-ecran-acces';
  var ua = navigator.userAgent;
  var IOS = /iPad|iPhone|iPod/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  var ANDROID = /Android/i.test(ua);
  var IN_APP = /Instagram|FBAN|FBAV|FB_IAB|FBIOS|Snapchat|TikTok|musical_ly|Bytedance|\bLine\//i.test(ua);
  var EXT = { 'image/jpeg': 'jpg', 'image/png': 'png', 'image/webp': 'webp', 'image/avif': 'avif', 'image/heic': 'heic' };

  /* ------------------------------------------------------------------ zip */

  var TABLE_CRC = (function () {
    var t = new Uint32Array(256);
    for (var n = 0; n < 256; n++) {
      var c = n;
      for (var k = 0; k < 8; k++) { c = c & 1 ? 0xedb88320 ^ (c >>> 1) : c >>> 1; }
      t[n] = c >>> 0;
    }
    return t;
  })();

  function crc32(octets) {
    var c = 0xffffffff;
    for (var i = 0; i < octets.length; i++) { c = TABLE_CRC[(c ^ octets[i]) & 0xff] ^ (c >>> 8); }
    return (c ^ 0xffffffff) >>> 0;
  }

  /* Zip « stocke » (methode 0) : en-tete local + donnees par fichier, puis repertoire central. */
  function fabriquerZip(fichiers) {
    var texte = new TextEncoder();
    var d = new Date();
    var heure = (d.getHours() << 11) | (d.getMinutes() << 5) | (d.getSeconds() >> 1);
    var jour = ((d.getFullYear() - 1980) << 9) | ((d.getMonth() + 1) << 5) | d.getDate();
    var morceaux = [], central = [], position = 0;

    fichiers.forEach(function (f) {
      var nom = texte.encode(f.nom);
      var crc = crc32(f.octets);
      var taille = f.octets.length;

      var local = new DataView(new ArrayBuffer(30));
      local.setUint32(0, 0x04034b50, true);
      local.setUint16(4, 20, true);
      local.setUint16(6, 0x0800, true);           // noms en UTF-8
      local.setUint16(8, 0, true);                // stocke, sans compression
      local.setUint16(10, heure, true);
      local.setUint16(12, jour, true);
      local.setUint32(14, crc, true);
      local.setUint32(18, taille, true);
      local.setUint32(22, taille, true);
      local.setUint16(26, nom.length, true);
      local.setUint16(28, 0, true);
      morceaux.push(local, nom, f.octets);

      var entree = new DataView(new ArrayBuffer(46));
      entree.setUint32(0, 0x02014b50, true);
      entree.setUint16(4, 20, true);
      entree.setUint16(6, 20, true);
      entree.setUint16(8, 0x0800, true);
      entree.setUint16(10, 0, true);
      entree.setUint16(12, heure, true);
      entree.setUint16(14, jour, true);
      entree.setUint32(16, crc, true);
      entree.setUint32(20, taille, true);
      entree.setUint32(24, taille, true);
      entree.setUint16(28, nom.length, true);
      entree.setUint32(42, position, true);       // le reste (commentaires, attributs) a 0
      central.push(entree, nom);

      position += 30 + nom.length + taille;
    });

    var tailleCentral = central.reduce(function (s, p) { return s + p.byteLength; }, 0);
    var fin = new DataView(new ArrayBuffer(22));
    fin.setUint32(0, 0x06054b50, true);
    fin.setUint16(8, fichiers.length, true);
    fin.setUint16(10, fichiers.length, true);
    fin.setUint32(12, tailleCentral, true);
    fin.setUint32(16, position, true);

    return new Blob(morceaux.concat(central, [fin]), { type: 'application/zip' });
  }

  function enregistrer(blob, nom) {
    var url = URL.createObjectURL(blob);
    var a = document.createElement('a');
    a.href = url;
    a.download = nom;
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(function () { URL.revokeObjectURL(url); }, 60000);
  }

  /* --------------------------------------------------------------- acces */

  function noterAcces() {
    try { localStorage.setItem(CLE, '1'); } catch (e) {}
  }

  /* --------------------------------------------------------------- packs */

  function init(racine) {
    if (racine.dataset.rpInit) { return; }
    racine.dataset.rpInit = '1';

    var msg = {
      preparation: racine.dataset.msgPreparation || 'Préparation du pack…',
      ok: (IOS ? racine.dataset.msgOkIphone : ANDROID ? racine.dataset.msgOkAndroid : racine.dataset.msgOkOrdi) || 'C\'est téléchargé.',
      photosPret: racine.dataset.msgPhotosPret || 'Images prêtes : touche de nouveau le bouton.',
      erreur: racine.dataset.msgErreur || 'Le téléchargement a échoué. Réessaie.'
    };

    if (racine.classList.contains('rp-fonds--ouvert') && !racine.hasAttribute('data-force')) {
      noterAcces();
      /* Navigateur d'une appli : « Ouvrir dans le navigateur » reprend l'adresse, qui doit donc
         porter l'acces (le localStorage de l'appli n'est pas celui de Safari/Chrome). */
      if (IN_APP && !/[?&](customer_posted=true|acces=1)/.test(location.search)) {
        try {
          var adresse = new URL(location.href);
          adresse.searchParams.set('acces', '1');
          history.replaceState(history.state, '', adresse.toString());
        } catch (e) {}
      }
    }

    var avertissement = racine.querySelector('[data-in-app]');
    if (IN_APP && avertissement) { avertissement.hidden = false; }

    /* Selecteur Telephone / Ordinateur : le CSS n'affiche que les packs du format de data-format. */
    var choix = racine.querySelectorAll('[data-choisir-format]');
    function montrerFormat(format) {
      racine.setAttribute('data-format', format);
      choix.forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.choisirFormat === format)); });
    }
    choix.forEach(function (b) {
      b.addEventListener('click', function () { montrerFormat(b.dataset.choisirFormat); });
    });
    if (choix.length) { montrerFormat(racine.getAttribute('data-format') || 'telephone'); }

    var partageFichiers = false;
    try {
      partageFichiers = IOS && !!navigator.canShare &&
        navigator.canShare({ files: [new File([new Uint8Array(1)], 'test.jpg', { type: 'image/jpeg' })] });
    } catch (e) {}

    racine.querySelectorAll('[data-pack]').forEach(function (pack) {
      var etat = { fichiers: null, zip: null, partage: null, occupe: false };
      var base = pack.dataset.nom || 'Records-Posters_Fonds-ecran';
      var statut = pack.querySelector('.rp-fonds__statut');
      var boutonZip = pack.querySelector('[data-telecharger]');
      var boutonPhotos = pack.querySelector('[data-photos]');

      function dire(texte, genre) {
        statut.textContent = texte;
        statut.classList.toggle('rp-fonds__statut--ok', genre === 'ok');
        statut.classList.toggle('rp-fonds__statut--erreur', genre === 'erreur');
      }

      async function charger() {
        if (etat.fichiers) { return etat.fichiers; }
        var liens = Array.prototype.slice.call(pack.querySelectorAll('[data-fond]'));
        var faits = 0;
        dire(msg.preparation + ' 0/' + liens.length);
        var fichiers = await Promise.all(liens.map(async function (lien, i) {
          var reponse = await fetch(lien.dataset.fond, { credentials: 'same-origin' });
          if (!reponse.ok) { throw new Error('HTTP ' + reponse.status); }
          var type = (reponse.headers.get('content-type') || 'image/jpeg').split(';')[0].trim();
          var octets = new Uint8Array(await reponse.arrayBuffer());
          faits += 1;
          dire(msg.preparation + ' ' + faits + '/' + liens.length);
          var numero = String(i + 1).padStart(2, '0');
          return { nom: base + '_' + numero + '.' + (EXT[type] || 'jpg'), type: type, octets: octets };
        }));
        etat.fichiers = fichiers;
        return fichiers;
      }

      async function occuper(bouton, travail) {
        if (etat.occupe) { return; }
        etat.occupe = true;
        bouton.setAttribute('aria-busy', 'true');
        try {
          await travail();
        } catch (e) {
          if (e && e.name === 'AbortError') { dire(''); }   // feuille de partage refermee
          else { dire(msg.erreur, 'erreur'); }
        } finally {
          etat.occupe = false;
          bouton.removeAttribute('aria-busy');
        }
      }

      boutonZip.addEventListener('click', function () {
        occuper(boutonZip, async function () {
          if (!etat.zip) { etat.zip = fabriquerZip(await charger()); }
          enregistrer(etat.zip, base + '.zip');
          dire(msg.ok, 'ok');
        });
      });

      if (partageFichiers && boutonPhotos) {
        boutonPhotos.hidden = false;
        boutonPhotos.addEventListener('click', function () {
          occuper(boutonPhotos, async function () {
            var pret = !!etat.partage;
            if (!pret) {
              etat.partage = (await charger()).map(function (f) { return new File([f.octets], f.nom, { type: f.type }); });
            }
            try {
              await navigator.share({ files: etat.partage });
              dire('');
            } catch (e) {
              /* Safari refuse le partage quand le chargement a fait perdre le « geste » du toucher :
                 les images sont pretes, un second toucher suffit. */
              if (e && e.name === 'NotAllowedError' && !pret) { dire(msg.photosPret); return; }
              throw e;
            }
          });
        });
      }
    });
  }

  function initTout() {
    document.querySelectorAll('[data-rp-fonds]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTout);
  } else {
    initTout();
  }
  document.addEventListener('shopify:section:load', initTout);
})();
